
<p-card> 
    <div class="grid">
        <div class="col-12">
            Locations: <p-dropdown placeholder="Select a Location" [options]="locations" [(ngModel)]="selectedLocation" optionLabel="value" optionValue="key"  (onChange)="locationChange()"></p-dropdown>
        </div>
        <div class="col-12">
            Stocks: <p-dropdown placeholder="Select a Stock" [options]="stocks" [(ngModel)]="selectedStock" optionLabel="value" optionValue="key" (onChange)="stockChange()"></p-dropdown>
        </div>
        <div class="col-12">
            <div style="text-align: center;">
                <p-progressSpinner *ngIf="showSpinner && !first"></p-progressSpinner>
            </div>
        </div>
        <div *ngIf="graphData != null && graphData.datasets.length > 0" class="col-2">
            <p-button label="Deselect All" (onClick)="deselectAll()"></p-button>
        </div>
        <div *ngIf="graphData != null && graphData.datasets.length > 0" class="col-2">
            <p-button label="Select All" (onClick)="selectAll()"></p-button>
        </div>
        <div class="col-12">
            <p-chart *ngIf="!showSpinner" type="line" [data]="graphData" height="80vh"></p-chart>
        </div>
        <div *ngIf="graphData != null && graphData.datasets.length > 0" class="col-2">
            <p-button label="Show Details" (onClick)="showDetails = true;"></p-button>
        </div>
        <div *ngIf="graphData != null && graphData.datasets.length > 0" class="col-2">
            <p-button label="Hide Details" (onClick)="showDetails = false;"></p-button>
        </div>
        <div *ngIf="selectedLocation != 0 && selectedStock != 0 && showDetails" class="col-12">
            <div *ngFor="let date of chartData.dates; index as i" class="grid">
                <div class="col-12">
                    {{date}}
                </div>
                <div class="flex">
                    <div *ngFor="let probe of probeNames" class="mr-1" style="min-width: 35px;">
                        <div *ngFor="let sample of sampleNames[i]">
                            {{getSampleProbeResult(sample, probe, i)}}
                        </div>
                    </div>
                </div>
                <br><br>
            </div>
        </div>
    </div>
</p-card>
<!--We might use this for the minimuga data yet.  IDK for sure.
<p-card> 
    <div class="grid">
        <div class="field col-2">
            <label for="days" style="margin-right: 10px;">Source:</label>
            <div class="flex align-items-center">
                <p-radioButton
                    name="dataSource" 
                    value="tyx" 
                    [(ngModel)]="dataSource" 
                    inputId="dataSource1"></p-radioButton>
                <label for="dataSource1" class="ml-2">
                    Transnetyx
                </label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton
                    name="dataSource" 
                    value="minimuga" 
                    [(ngModel)]="dataSource" 
                    inputId="dataSource2"></p-radioButton>
                <label for="dataSource2" class="ml-2">
                    MiniMUGA
                </label>
            </div>
        </div>
        <div class="field col-2">
            <label for="days" style="margin-right: 10px;">Analysis type:</label>
            <div class="flex align-items-center">
                <p-radioButton
                    name="analysisType" 
                    value="individual" 
                    [(ngModel)]="analysisType" 
                    inputId="analysisType1"></p-radioButton>
                <label for="analysisType" class="ml-2">
                    Individual
                </label>
            </div>
            
            <div class="flex align-items-center">
                <p-radioButton
                    name="analysisType" 
                    value="group" 
                    [(ngModel)]="analysisType" 
                    inputId="analysisType2"></p-radioButton>
                <label for="analysisType2" class="ml-2">
                    Group
                </label>
            </div>
            
            <div class="flex align-items-center">
                <p-radioButton
                    name="analysisType" 
                    value="stock" 
                    [(ngModel)]="analysisType" 
                    inputId="analysisType3"></p-radioButton>
                <label for="analysisType3" class="ml-2">
                    Stock
                </label>
            </div>
        </div>

        <div *ngIf="analysisType=='individual'" class="field col-8">
            <div class="grid">
                <div class="field col-3">
                    <p-dropdown 
                        [options]="samples" 
                        [(ngModel)]="selectedSamples" 
                        [filter]="true"
                        optionLabel="name" 
                        optionValue="id"
                        placeholder="Select a Sample" >
                    </p-dropdown>
                </div>
            </div>
        </div>

        <div *ngIf="analysisType=='group'" class="field col-8">
            <div class="grid">
                <div class="field col-3">
                    <p-dropdown 
                        [options]="strains" 
                        [(ngModel)]="selectedStrains" 
                        [filter]="true"
                        optionLabel="name" 
                        optionValue="id"
                        placeholder="Select a Strain" >
                    </p-dropdown>
                </div>
                <div class="field col-4">
                    <p-multiSelect 
                        [options]="samples" 
                        [(ngModel)]="selectedSamples" 
                        [filter]="true" 
                        optionLabel="name" 
                        optionValue="id"
                        placeholder="Select Samples" >
                    </p-multiSelect>
                </div>
            </div>
        </div>
        <div *ngIf="analysisType=='stock'" class="field col-8">
            <div class="grid">
                <div class="field col-3">
                    <p-dropdown 
                        [options]="locations" 
                        [(ngModel)]="selectedLocations" 
                        [filter]="true"
                        optionLabel="name" 
                        optionValue="id"
                        placeholder="Select a Location" >
                    </p-dropdown>
                </div>
                <div class="field col-3">
                    <p-dropdown 
                        [options]="strains" 
                        [(ngModel)]="selectedStrains" 
                        [filter]="true"
                        optionLabel="name" 
                        optionValue="id"
                        placeholder="Select a Strain" >
                    </p-dropdown>
                </div>
                <div class="field col-4">
                    <p-multiSelect 
                        [options]="samples" 
                        [(ngModel)]="selectedSamples" 
                        [filter]="true" 
                        optionLabel="name" 
                        optionValue="id"
                        placeholder="Select Samples" >
                    </p-multiSelect>
                </div>
            </div>
        </div>
        
        <div class="field col-12">
            <hr>
        </div>
        <div class="field col-12">
            <p-button (onClick)="PopulateData($event)" label="Pull data"></p-button>
        </div>
        <div *ngIf="analysisType=='individual' && showStats" class="field col-12">
            <h4>Sample stats:</h4>
            <br>
            Het sites: R18, R22, R24
            <br>
            Percent het: 8%
        </div>
        <div *ngIf="analysisType=='group' && showStats" class="field col-12">
            <h4>Strain wide stats:</h4>
            <br>
            Het sites: R18, R22, R24, R75, R80
            <br>
            Genotype frequency: 10% het, 40% hom pos, 50% hom neg.
            <br>
            Average individual percent het: 12%
            <br>
            Site wide het: 20%
        </div>
        <div *ngIf="analysisType=='stock' && showStats" class="field col-12">
            <h4>Loction wide stats:</h4>
            <br>
            Het sites: R18, R22, R24, R75, R80
            <br>
            Genotype frequency: 10% het, 40% hom pos, 50% hom neg.
            <br>
            Average individual percent het: 12%
            <br>
            Site wide het: 20%
        </div>
    </div>
</p-card>-->